<nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
  <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
    <a class="navbar-brand brand-logo" href="index.html">
      <img src="assets/images/logo.png" alt="logo" class="logo-dark" />
      <img src="assets/images/logo.png" alt="logo-light" class="logo-light">
    </a>
    <a class="navbar-brand brand-logo-mini" href="index.html"><img src="assets/images/logo.png" alt="logo" /></a>
    <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize"
            (click)="toggleSidebar()">
      <span class="icon-menu"></span>
    </button>
  </div>
  <div class="navbar-menu-wrapper d-flex align-items-center">
    <h5 class="mb-0 fw-medium d-none d-lg-flex">{{'NAVBAR.WELCOME' | translate}} {{userDisplayName}}</h5>
    <ul class="navbar-nav navbar-nav-right">
      <!--<form class="search-form d-none d-md-block" action="#">
        <i class="icon-magnifier"></i>
        <input type="search" class="form-control" placeholder="{{'Search Here'}}" title="{{'Search Here'}}">
      </form>-->

      <li class="nav-item dropdown language-dropdown d-none d-sm-flex align-items-center" ngbDropdown>
        <a class="nav-link d-flex align-items-center dropdown-toggle" id="LanguageDropdown" ngbDropdownToggle aria-expanded="false">
          <span class="profile-text fw-normal">{{('NAVBAR.LANGUAGES.' + translate.currentLang | uppercase) | translate}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-start navbar-dropdown py-2" ngbDropdownMenu aria-labelledby="LanguageDropdown">
          <a class="dropdown-item" *ngFor="let lang of supportedLanguages" (click)="changeLang(lang)">
            <span>{{('NAVBAR.LANGUAGES.' + lang | uppercase) | translate}}</span>
          </a>
        </div>
      </li>

      <li class="nav-item dropdown d-xl-inline-flex user-dropdown" ngbDropdown>
        <a class="nav-link dropdown-toggle" id="UserDropdown" ngbDropdownToggle aria-expanded="false">
          <!--<img class="img-xs rounded-circle ml-2" src="assets/images/faces/face8.jpg" alt="Profile image">-->
          <i class="mdi mdi-account-circle fs-2 me-2"></i>
          <span class="fw-normal">{{ userDisplayName }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-end navbar-dropdown" ngbDropdownMenu aria-labelledby="UserDropdown">
          <div class="dropdown-header text-center">
            <i class="mdi mdi-account-circle fs-2"></i>
            <p>{{ userEmail }}</p>
          </div>
          <!--<a class="dropdown-item">
            <i class="dropdown-item-icon icon-user text-primary"></i>
            <span>My Profile</span> <span class="badge badge-pill badge-danger">1</span>
          </a>
          <a class="dropdown-item">
            <i class="dropdown-item-icon icon-question text-primary"></i>
            <span>FAQ</span>
          </a>
          <div class="dropdown-divider"></div>-->
          <a class="dropdown-item" (click)="logout()">
            <i class="dropdown-item-icon icon-power text-primary"></i>
            <span>{{'NAVBAR.LOG_OUT' | translate}}</span>
          </a>
        </div>
      </li>
    </ul>
    <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
            (click)="toggleOffcanvas()">
      <span class="icon-menu"></span>
    </button>
  </div>
</nav>
